import React from "react";
import { TextAndImageParallaxBlock } from "../../lib/storyblok/types/blocks/textAndImageParallaxBlock";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import { useLinks } from "../../lib/storyblok/useLinks";
import { imageSizes, isValidImageData } from "../../lib/utils/imageUtils";
import Button from "../../ui/Button";
import MediaAndImageUi from "../../ui/MediaAndImage";
import StoryblokImage from "../StoryblokImage";

const TextAndImageParallax: StoryblokBlockComponent<
  TextAndImageParallaxBlock
> = ({
  text,
  title,
  image,
  buttonText,
  buttonLink,
  secondButtonText,
  secondButtonLink,
  typeformCopy,
  typeformID,
  typeformSize,
  typeformButtonStyle,
  outerSpacing,
  mediaBackground,
  imageKeepProportions,
  layout,
  style,
}) => {
  const resolveLink = useLinks();

  return (
    <MediaAndImageUi
      style={style}
      reversed={true}
      title={title}
      preamble={text}
      image={
        isValidImageData(image) && (
          <StoryblokImage
            sizes={imageSizes("100vw", {
              desktop: "1200px",
              xl: "1600px",
            })}
            image={image}
            layout="fill"
            alt={title}
          />
        )
      }
      button={
        buttonText && (
          <Button href={resolveLink(buttonLink)} variant="inverted">
            {buttonText}
          </Button>
        )
      }
      secondButton={
        secondButtonText && (
          <Button href={resolveLink(secondButtonLink)} variant="inverted">
            {secondButtonText}
          </Button>
        )
      }
      typeformCopy={typeformCopy}
      typeformID={typeformID}
      typeformSize={typeformSize}
      typeformButtonStyle={typeformButtonStyle}
      outerSpacing={outerSpacing}
      mediaBackground={mediaBackground}
      imageKeepProportions={imageKeepProportions}
      layout={layout}
    />
  );
};

export default TextAndImageParallax;
